"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_support.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Support(_ref) {
  var accountManager = _ref.accountManager,
      supportContact = _ref.supportContact;
  var firstName = accountManager.firstName,
      lastName = accountManager.lastName,
      email = accountManager.email,
      imageUrl = accountManager.imageUrl,
      phoneNumber = accountManager.phoneNumber;
  return _react.default.createElement("div", {
    className: "subscription-support"
  }, _react.default.createElement("div", {
    className: "subscription-support__label"
  }, _react.default.createElement(_uiKit.Icon, {
    name: "user",
    size: 20,
    color: "russian"
  }), _react.default.createElement("p", null, "Support")), _react.default.createElement("div", {
    className: "subscription-support__container"
  }, _react.default.createElement("div", {
    className: "subscription-support__container__account-manager"
  }, _react.default.createElement(_uiKit.Image, {
    imageUrl: imageUrl,
    defaultIconBackground: "catSkillWhite",
    defaultIconColour: "michael",
    width: "90px",
    height: "90px",
    backgroundSize: "cover"
  }), _react.default.createElement("div", {
    className: "subscription-support__container__account-manager__details"
  }, _react.default.createElement("p", {
    className: "subscription-support__container__account-manager__details__name"
  }, "".concat(firstName, " ").concat(lastName)), _react.default.createElement("p", {
    className: "subscription-support__container__account-manager__details__position"
  }, "Account manager"), _react.default.createElement("p", {
    className: "subscription-support__container__account-manager__details__contact-info"
  }, "".concat(phoneNumber, " | "), _react.default.createElement("u", null, email)))), _react.default.createElement("div", {
    className: "subscription-support__container__support-team"
  }, _react.default.createElement(_uiKit.Image, {
    defaultImageIcon: "shootstacolour",
    defaultIconBackground: "black",
    width: "90px",
    height: "90px"
  }), _react.default.createElement("div", {
    className: "subscription-support__container__support-team__details"
  }, _react.default.createElement("p", {
    className: "subscription-support__container__support-team__details__name"
  }, "SHOOTSTA SUPPORT TEAM"), _react.default.createElement("p", {
    className: "subscription-support__container__support-team__details__message"
  }, "We\u2019ll get back to you as soon as possible"), _react.default.createElement("p", {
    className: "subscription-support__container__support-team__details__contact-info"
  }, _react.default.createElement("span", null, "".concat(supportContact.phone, " | ")), _react.default.createElement("u", null, supportContact.email))))));
}

var _default = (0, _react.memo)(Support);

exports.default = _default;